var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8076 13.541C15.8076 13.5697 15.8076 13.5983 15.8076 13.627C15.8363 13.5983 15.8363 13.5697 15.8076 13.541Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6004 8.72559C7.37989 8.72559 7.26523 9.27024 7.26523 13.5988C7.26523 17.9274 7.37989 18.4721 13.6004 18.4721C19.821 18.4721 19.9356 17.9274 19.9356 13.5988C19.9643 9.27024 19.8496 8.72559 13.6004 8.72559ZM15.6357 13.9141L12.7691 15.2901C12.5398 15.4048 12.2818 15.2328 12.2818 14.9748V12.2802C12.2818 12.0222 12.5398 11.8502 12.7691 11.9649L15.6357 13.2835C15.7504 13.3408 15.8077 13.4268 15.8364 13.5415C15.8364 13.5702 15.8364 13.5988 15.8364 13.6275C15.8077 13.7422 15.7504 13.8568 15.6357 13.9141Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube);
export default __webpack_public_path__ + "static/media/logoYoutube.4ab7af53b7a3a7a318d4fe798a193b96.svg";
export { ForwardRef as ReactComponent };